// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".update-contract-dialog.common-dialog[data-v-ff1e70aa] .el-dialog{width:var(--common-dialog-medium-width)}.update-contract-dialog.common-dialog .el-form[data-v-ff1e70aa]{margin-right:var(--common-dialog-form-margin-right)}", ""]);
// Exports
module.exports = exports;
